var map = {
	"./classroom_1.jpg": "70c4",
	"./classroom_2.jpg": "d0e0",
	"./classroom_3.jpg": "a571",
	"./classroom_4.jpg": "d7f9",
	"./classroom_5.jpg": "1f44",
	"./hall_1.jpg": "ca26",
	"./hall_2.jpg": "07c0",
	"./hall_3.jpg": "9a43",
	"./hall_4.jpg": "6e28",
	"./hall_5.jpg": "b506",
	"./living_1.jpg": "ba33",
	"./living_2.jpg": "aa2e",
	"./living_3.jpg": "53ae",
	"./living_4.jpg": "61a8",
	"./living_5.jpg": "be6e",
	"./meeting_1.jpg": "2da6",
	"./meeting_2.jpg": "a8c8",
	"./meeting_3.jpg": "d8c3",
	"./meeting_4.jpg": "93d5",
	"./meeting_5.jpg": "24b8",
	"./result_ceil.jpg": "1e03",
	"./result_ceil_angle.jpg": "2b40",
	"./result_ceil_lx.jpg": "9265",
	"./result_ceil_lx_angle.jpg": "c0ce",
	"./result_celling.jpg": "be2c",
	"./result_desk.jpg": "7405",
	"./result_desk_angle.jpg": "3128",
	"./result_desk_lx.jpg": "5f92",
	"./result_desk_lx_angle.jpg": "03c6",
	"./result_desktop.jpg": "a9b3",
	"./theatre_1.jpg": "6935",
	"./theatre_2.jpg": "8b17",
	"./theatre_3.jpg": "fbee",
	"./theatre_4.jpg": "2a2c",
	"./theatre_5.jpg": "f59b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22be";